e4.handlebars = {
    debug: false,
    init: function () {
    },
    getTemplateName: function ( strTemplateSelector ) {
        return jQuery.camelCase( strTemplateSelector.substring( 1 ).replace( 'js-e-handlebars-tmpl-', '' ) );
    },
    compileTemplate: function ( strTemplateSelector, boolIsPartial ) {
        var tmplName = e4.handlebars.getTemplateName( strTemplateSelector ),
            jTmpl = jQuery( strTemplateSelector ).first(),
            strTmplHtml = jTmpl.html();
        if ( jTmpl.length === 1 ) {
            if ( boolIsPartial === true ) {
                Handlebars.registerPartial( tmplName, strTmplHtml );
                e4.handlebars.partial[ tmplName ] = Handlebars.compile( strTmplHtml );
            }
            else {
                e4.handlebars.tmpl[ tmplName ] = Handlebars.compile( strTmplHtml );
            }
        }
    },
    tmpl: {},
    registerTemplates: function ( strTemplates ) {
        var arrTemplates = strTemplates.split( ' ' );
        for ( var i = 0; i < arrTemplates.length; i++ ) {
            e4.handlebars.compileTemplate( arrTemplates[ i ] );
        }
    },
    partial: {},
    registerPartials: function ( strPartials ) {
        var arrPartials = strPartials.split( ' ' );
        for ( var i = 0; i < arrPartials.length; i++ ) {
            e4.handlebars.compileTemplate( arrPartials[ i ], true );
        }
    },
    registerHelpers: function ( strHelpers ) {
        var arrHelpers = strHelpers.split( ' ' );
        for ( var i = 0; i < arrHelpers.length; i++ ) {
            if ( window.Handlebars.helpers[ arrHelpers[ i ] ] === undefined ) {
                e4.handlebars.helpers[ arrHelpers[ i ] ]();
            }
        }
    },
    helpers: {
        /* jshint ignore:start */
        compare: function () {
            Handlebars.registerHelper( 'compare', function ( v1, operator, v2, options ) {
                switch ( operator ) {
                    case '===':
                        return ( v1 === v2 ) ? options.fn( this ) : options.inverse( this );
                    case '!==':
                        return ( v1 !== v2 ) ? options.fn( this ) : options.inverse( this );
                    case '<':
                        return ( v1 < v2 ) ? options.fn( this ) : options.inverse( this );
                    case '<=':
                        return ( v1 <= v2 ) ? options.fn( this ) : options.inverse( this );
                    case '>':
                        return ( v1 > v2 ) ? options.fn( this ) : options.inverse( this );
                    case '>=':
                        return ( v1 >= v2 ) ? options.fn( this ) : options.inverse( this );
                    case '&&':
                        return ( v1 && v2 ) ? options.fn( this ) : options.inverse( this );
                    case '||':
                        return ( v1 || v2 ) ? options.fn( this ) : options.inverse( this );
                    case '!!':
                        return ( !v1 && !v2 ) ? options.fn( this ) : options.inverse( this );
                    case '!|':
                        return ( !v1 && v2 ) ? options.fn( this ) : options.inverse( this );
                    case '|!':
                        return ( v1 && !v2 ) ? options.fn( this ) : options.inverse( this );
                    default:
                        return options.inverse( this );
                }
            } );
        },
        /* jshint ignore:end */
        counter: function () {
            Handlebars.registerHelper( 'counter', function ( index ) {
                return index + 1;
            } );
        }
    }
};

